export enum DeviceScheduleContentType {
  Default = 'Default',
  Playlist = 'Playlist',
  NewAsset = 'NewAsset',
  EventAsset = 'EventAsset',
  OrganizationAsset = 'OrganizationAsset'
}
